var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:[
    'icon',
    `theme--${_vm.theme}`,
    `icon--${_vm.name}`,
  ],attrs:{"to":_vm.tag === 'router-link' ? _vm.parsedTo : undefined,"href":_vm.tag === 'a' ? _vm.parsedTo : undefined,"target":_vm.tag === 'a' ? '_blank' : undefined},on:{"click":function($event){$event.stopPropagation();return _vm.fn.apply(null, arguments)}}},[_c('inline-svg',{attrs:{"src":require(`@/assets/svg/icons/${_vm.name}.svg`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }